import React from 'react';
import classNames from 'classnames';
import Icons from '../../../components/Icons/Icons';
import { NamedLink } from '../../../components';
import Slider from 'react-slick';
import '../../../styles/slick/slick.css';
import '../../../styles/slick/slick-theme.css';
import autographIcon from '../Assets/autographs.png';
import perksIcon from '../../../assets/Perks.svg';
import shoutoutIcon from '../Assets/shoutout.png';
import auctionIcon from '../../../assets/auction-svgrepo-com.svg';
import campaignIcon from '../Assets/campaign.svg';
import couponIcon from '../Assets/coupon.svg';
import crowdsourcingIcon from '../Assets/Crowdsourcing.svg';

import css from './Sections.module.css';
import { UserType } from '../../../util/enums';

const getSteps = intl => [
  {
    icon: autographIcon,
    isImage: true,
    title: intl.formatMessage({ id: 'ExploreServices.SignatureServices.title' }),
    description: intl.formatMessage({ id: 'ExploreServices.SignatureServices.description' }),
    linkName: intl.formatMessage({ id: 'ExploreServices.SignatureServices.linkName' }),
    linkDestination: 'SearchPage',
  },
  {
    icon: shoutoutIcon,
    isImage: true,
    title: intl.formatMessage({ id: 'ExploreServices.EnhancedServices.title' }),
    description: intl.formatMessage({ id: 'ExploreServices.EnhancedServices.description' }),
    linkName: intl.formatMessage({ id: 'ExploreServices.EnhancedServices.linkName' }),
    linkDestination: 'SearchPage',
  },
  {
    icon: auctionIcon,
    isImage: true,
    title: intl.formatMessage({ id: 'ExploreServices.Auctions.title' }),
    description: intl.formatMessage({ id: 'ExploreServices.Auctions.description' }),
    linkName: intl.formatMessage({ id: 'ExploreServices.Auctions.linkName' }),
    linkDestination: 'SearchPage',
  },
  {
    icon: perksIcon,
    isImage: true,
    title: intl.formatMessage({ id: 'ExploreServices.Perks.title' }),
    description: intl.formatMessage({ id: 'ExploreServices.Perks.description' }),
    linkName: intl.formatMessage({ id: 'ExploreServices.Perks.linkName' }),
    linkDestination: 'SearchPage',
  },
  {
    icon: 'money',
    title: intl.formatMessage({ id: 'ExploreServices.Jobs.title' }),
    description: intl.formatMessage({ id: 'ExploreServices.Jobs.description' }),
    linkName: intl.formatMessage({ id: 'ExploreServices.Jobs.linkName' }),
    linkDestination: 'SearchPage',
  },
  {
    icon: campaignIcon,
    isImage: true,
    title: intl.formatMessage({ id: 'ExploreServices.Campaigns.title' }),
    description: intl.formatMessage({ id: 'ExploreServices.Campaigns.description' }),
    linkName: intl.formatMessage({ id: 'ExploreServices.Campaigns.linkName' }),
    linkDestination: 'SearchPage',
  },
  {
    icon: couponIcon,
    isImage: true,
    title: intl.formatMessage({ id: 'ExploreServices.Coupons.title' }),
    description: intl.formatMessage({ id: 'ExploreServices.Coupons.description' }),
    linkName: intl.formatMessage({ id: 'ExploreServices.Coupons.linkName' }),
    linkDestination: 'SearchPage',
  },
  {
    icon: crowdsourcingIcon,
    isImage: true,
    title: intl.formatMessage({ id: 'ExploreServices.Crowdsourcing.title' }),
    description: intl.formatMessage({ id: 'ExploreServices.Crowdsourcing.description' }),
    linkName: intl.formatMessage({ id: 'ExploreServices.Crowdsourcing.linkName' }),
    linkDestination: 'SearchPage',
  },
];

function Step({ step, onRedirect }) {
  return (
    <div className={css.block}>
      <div className={css.blockTopInfo}>
        <div className={css.icons} role="button" onClick={onRedirect}>
          {step?.isImage ? <img src={step?.icon} /> : <Icons name={step.icon} />}
        </div>
        <h3>{step.title}</h3>
        <p>{step.description}</p>
      </div>
      <NamedLink className={css.findLink} name={step?.linkDestination || 'LandingPage'}>
        {step.linkName} <Icons name="rightArrow" />{' '}
      </NamedLink>
    </div>
  );
}

function ExploreServices(props) {
  const { useHistoryPush, intl, isMobileLayout } = props;

  const steps = getSteps(intl);

  return (
    <div
      className={classNames(
        css.howItWorks,
        css.blackBgWrapper,
        css.popularSessions,
        css.sectionPadding
      )}
    >
      <div className={css.contentWidth}>
        <div className={css.sectionHead}>
          <div className={css.leftSec}>
            <h2>{intl.formatMessage({ id: 'ExploreServices.title' })}</h2>
            <p>{intl.formatMessage({ id: 'ExploreServices.description' })}</p>
          </div>
          <div className={css.rightSec}>
            <NamedLink
              className={css.viewbtn}
              name="SearchPage"
              to={{
                pub_listingCategory: UserType.TALENT,
              }}
            >
              {intl.formatMessage({ id: 'ExploreServices.viewAll' })}
            </NamedLink>
          </div>
        </div>
        <div className={css.sectionContent}>
          <div className={css.featuredListingsContent}>
            <div className={css.templatesSlider}>
              <Slider {...{ ...sliderSettings, arrows: !isMobileLayout }}>
                {steps.map((step, index) => (
                  <Step
                    key={index}
                    step={step}
                    onRedirect={() => useHistoryPush(step.linkDestination)}
                  />
                ))}
              </Slider>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

// Default slider settings
const sliderSettings = {
  dots: false,
  arrows: true,
  infinite: false,
  autoplay: false,
  autoplaySpeed: 2000,
  speed: 500,
  slidesToShow: 4,
  slidesToScroll: 1,
  variableWidth: false,
  focusOnSelect: false,
  centerMode: false,
  responsive: [
    {
      breakpoint: 1128,
      settings: {
        slidesToShow: 3,
        variableWidth: false,
      },
    },
    {
      breakpoint: 991,
      settings: {
        slidesToShow: 2,
        variableWidth: false,
      },
    },
    {
      breakpoint: 767,
      settings: {
        centerMode: true,
        slidesToShow: 1,
        variableWidth: false,
        dots: true,
      },
    },
    {
      breakpoint: 480,
      settings: {
        centerMode: true,
        slidesToShow: 1,
        variableWidth: false,
        dots: true,
      },
    },
  ],
};

ExploreServices.defaultProps = {
  sliderSettings,
};

export default ExploreServices;
